import type { GetAppsAppGroupIdUserImportsImportIdSearchEventCatalogResult } from "./types";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function isGetAppsAppGroupIdUserImportsImportIdSearchEventCatalogResult(
  value: unknown
): value is GetAppsAppGroupIdUserImportsImportIdSearchEventCatalogResult {
  if (!isRecord(value)) {
    return false;
  }
  const items = value.items;
  if (!Array.isArray(items)) {
    return false;
  }

  return items.every((item: unknown) => {
    return (
      isRecord(item) &&
      typeof item.name === "string" &&
      typeof item.data_type === "string" &&
      typeof item.blocklisted === "boolean"
    );
  });
}
